// extracted by mini-css-extract-plugin
export var accountLimit = "PartnerInvitationsPage-module__accountLimit___OaPTa";
export var announcement = "PartnerInvitationsPage-module__announcement___9xCDb";
export var choiceDescription = "PartnerInvitationsPage-module__choiceDescription___xhhZa";
export var choiceDetails = "PartnerInvitationsPage-module__choiceDetails___u9YKl";
export var choiceGroup = "PartnerInvitationsPage-module__choiceGroup___LK1b3";
export var choiceGroupLabel = "PartnerInvitationsPage-module__choiceGroupLabel___YfD+o";
export var choiceImage = "PartnerInvitationsPage-module__choiceImage___WyBU2";
export var choiceOption = "PartnerInvitationsPage-module__choiceOption___HplSQ";
export var choiceOptions = "PartnerInvitationsPage-module__choiceOptions___YGki4";
export var choiceOr = "PartnerInvitationsPage-module__choiceOr___dBVk8";
export var choiceTitle = "PartnerInvitationsPage-module__choiceTitle___rpVHH";
export var description = "PartnerInvitationsPage-module__description___-sJmi";
export var empty = "PartnerInvitationsPage-module__empty___XkPTh";
export var expiration = "PartnerInvitationsPage-module__expiration___10QO6";
export var invitationFormContainer = "PartnerInvitationsPage-module__invitationFormContainer___fiMZO";
export var invitationMetadata = "PartnerInvitationsPage-module__invitationMetadata___bs74w";
export var invitedBy = "PartnerInvitationsPage-module__invitedBy___O-B+-";
export var inviterEmail = "PartnerInvitationsPage-module__inviterEmail___B1ar3";
export var page = "PartnerInvitationsPage-module__page___4F9Od";
export var pageHeader = "PartnerInvitationsPage-module__pageHeader___e1R2Y";
export var reviewHeading = "PartnerInvitationsPage-module__reviewHeading___s27mO";
export var selectionActions = "PartnerInvitationsPage-module__selectionActions___+LXtr";
export var selectionFooter = "PartnerInvitationsPage-module__selectionFooter___ol0l1";
export var selectionPanel = "PartnerInvitationsPage-module__selectionPanel___HwCAl";
export var selectionTitle = "PartnerInvitationsPage-module__selectionTitle___N8cY0";
export var title = "PartnerInvitationsPage-module__title___JUEId";
export var transferWarning = "PartnerInvitationsPage-module__transferWarning___aFRtP";
export var transferWarningIcon = "PartnerInvitationsPage-module__transferWarningIcon___OzjUG";
export var unavailable = "PartnerInvitationsPage-module__unavailable___Vj+nC";
export var unavailableAction = "PartnerInvitationsPage-module__unavailableAction___p3OyZ";
export var unavailableDescription = "PartnerInvitationsPage-module__unavailableDescription___aGnSA";
export var unavailableImage = "PartnerInvitationsPage-module__unavailableImage___L69dv";
export var unavailableTitle = "PartnerInvitationsPage-module__unavailableTitle___Qbqir";